import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { RouteModel } from '../models/route';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiProvider } from '../providers/api.provider';

@Injectable({
  providedIn: 'root'
})
export class RouteService {
  private currentRouteSubject: BehaviorSubject<RouteModel>;
  public currentRoute: Observable<RouteModel>;
  constructor(private apiProvider: ApiProvider) {
    this.currentRouteSubject = new BehaviorSubject<RouteModel>(null);
  }

  public get currentRouteValue(): RouteModel {
    return this.currentRouteSubject.value;
  }

  getCurrentRouteObs(): Observable<RouteModel> {
    return this.currentRouteSubject.asObservable();
  }

  setCurrentRouteObs(routeModel: RouteModel) {
    this.currentRouteSubject.next(routeModel);
  }

  public updateRoute(
    routeID: number,
    routeDriverName: string,
    routeDriverPhone: string,
    routeDriverLanguage: string
  ) {
    this.apiProvider
      .UpdateRoute(
        routeID,
        routeDriverName,
        routeDriverPhone,
        routeDriverLanguage
      )
      .subscribe(() => {});
  }

  async initialiseRoute(routeID: number) {
    await this.apiProvider.GetRoute(routeID).subscribe(
      (route: RouteModel) => {
        this.currentRouteSubject = new BehaviorSubject<RouteModel>(route);
        this.currentRoute = this.currentRouteSubject.asObservable();
      },
      (err: HttpErrorResponse) => {
        this.currentRouteSubject.next(null);
      }
    );
  }
}
